import request from '@/utils/request'

/**
 * 统计信息
 * @param {array} params 请求参数
 */
export function reqStat(params) {
  return request({
    url: '/api/lottery.Stat/visit',
    method: 'get',
    params: params
  })
}